// Localized storefront display.
import { useStoreLanguage } from '@/i18n';
import { useEffect } from 'react';
import { useLocation, useNavigate } from '@/i18n/router';
import { supabaseClient, shouldUseSupabase } from '@/lib/supabaseClient';

export default function RedirectHandler() {
  useStoreLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkRedirect = async () => {
      // If Supabase shouldn't be used or the client isn't ready, exit early
      if (!shouldUseSupabase() || !supabaseClient) {
        return;
      }

      const currentPath = location.pathname;

      try {
        // Query for an active redirect that matches the current path
        const { data, error } = await supabaseClient
          .from('redirects')
          .select('id, source_path, destination_path')
          .eq('source_path', currentPath)
          .eq('is_active', true)
          .maybeSingle();

        if (error) {
          return;
        }

        if (data?.destination_path) {
          // External redirect
          if (data.destination_path.startsWith('http')) {
            window.location.replace(data.destination_path);
          } else {
            // Internal redirect using react‑router navigation
            navigate(data.destination_path, { replace: true });
          }
        }
      } catch {
        // redirect errors silently ignored
      }
    };

    checkRedirect();
  }, [location.pathname, navigate]);

  // This component does not render anything visible
  return null;
}
